import React, { useCallback, useEffect } from "react";
import { useWorkOrderFilters } from "../../../../features/work-order";
import { getErrorMessage } from "../../../../shared/lib/errors/getErrorMessage";
import { WorkOrderListView } from "./WorkOrderListView";

export const WorkOrderList: React.FC = () => {
  const { data, error, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, apiFilters } =
    useWorkOrderFilters();

  const items = data?.items ?? [];
  const filterKey = JSON.stringify(apiFilters);

  useEffect(() => {
    document.getElementById("scrollableDiv")?.scrollTo({ top: 0 });
  }, [filterKey]);

  const handleLoadMore = useCallback(() => {
    if (!hasNextPage || isFetchingNextPage) return;
    void fetchNextPage();
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  if (error)
    return (
      <div className="my-2 w-full rounded-md border border-[#E63312] bg-[#FFF3F0] p-3">
        <p className="font-['PT_Sans'] text-[16px] font-bold text-[#E63312]">
          {getErrorMessage(error)}
        </p>
      </div>
    );

  return (
    <WorkOrderListView
      key={filterKey}
      items={items}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasMore={Boolean(hasNextPage)}
      onLoadMore={handleLoadMore}
    />
  );
};
